import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <p className="text-gray-700 mb-4">
              <strong>Dernière mise à jour :</strong> Février 2025
            </p>
            <p className="text-gray-700">
              OPTIMHUB, éditeur du site 123pariez.com, s'engage à protéger la vie privée des utilisateurs 
              de son site. Cette politique de confidentialité explique comment nous collectons, utilisons 
              et protégeons vos données personnelles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Responsable du traitement</h2>
            <div className="text-gray-700 space-y-2">
              <p><strong>OPTIMHUB</strong></p>
              <p>11 Rue de Lourmel, 75015 Paris, France</p>
              <p>SIREN : 534 057 088</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Données collectées</h2>
            <p className="text-gray-700 mb-4">Nous pouvons collecter les données suivantes :</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées, durée de visite</li>
              <li><strong>Cookies :</strong> cookies techniques et analytiques (voir section dédiée)</li>
              <li><strong>Données volontairement fournies :</strong> en cas de contact via formulaire</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Finalités du traitement</h2>
            <p className="text-gray-700 mb-4">Vos données sont collectées pour :</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Améliorer l'expérience utilisateur sur notre site</li>
              <li>Analyser la fréquentation et l'utilisation du site</li>
              <li>Assurer la sécurité et le bon fonctionnement du site</li>
              <li>Répondre à vos éventuelles demandes de contact</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Base légale</h2>
            <p className="text-gray-700">
              Le traitement de vos données repose sur votre consentement (pour les cookies non essentiels) 
              et sur notre intérêt légitime (amélioration du service, sécurité du site).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Cookies</h2>
            <p className="text-gray-700 mb-4">Notre site utilise des cookies pour :</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site</li>
              <li><strong>Cookies analytiques :</strong> pour mesurer l'audience (avec votre consentement)</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Vous pouvez gérer vos préférences de cookies à tout moment via les paramètres de votre navigateur.
            </p>
            
            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-gray-700">
                <strong>OPTIMHUB</strong> participe et est conforme à l'ensemble des Spécifications et Politiques 
                du Transparency & Consent Framework de l'IAB Europe. Elle utilise la Consent Management Platform n°92.
              </p>
              <p className="text-gray-700 mt-3">
                Vous pouvez modifier vos choix à tout moment en{' '}
                <button 
                  onClick={() => { if (window.Sddan && window.Sddan.cmp) window.Sddan.cmp.displayUI(); }}
                  className="text-blue-600 hover:underline cursor-pointer"
                >
                  cliquant ici
                </button>.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Durée de conservation</h2>
            <p className="text-gray-700">
              Les données de navigation sont conservées pendant une durée maximale de 13 mois. 
              Les données de contact sont conservées pendant 3 ans à compter du dernier contact.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Partage des données</h2>
            <p className="text-gray-700">
              Vos données personnelles ne sont pas vendues ni transmises à des tiers à des fins commerciales. 
              Elles peuvent être partagées avec nos prestataires techniques (hébergement, analytics) 
              dans le strict cadre de leurs missions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Vos droits</h2>
            <p className="text-gray-700 mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
            <p className="text-gray-700 mt-4">
              Pour exercer ces droits, contactez-nous à l'adresse de notre siège social.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Sécurité</h2>
            <p className="text-gray-700">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour 
              protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Réclamation</h2>
            <p className="text-gray-700">
              Si vous estimez que le traitement de vos données ne respecte pas la réglementation, 
              vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de 
              l'Informatique et des Libertés) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">www.cnil.fr</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Modification de la politique</h2>
            <p className="text-gray-700">
              Cette politique de confidentialité peut être mise à jour. Nous vous invitons à la 
              consulter régulièrement. Toute modification sera effective dès sa publication sur cette page.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PolitiqueConfidentialite;
